import React from 'react';

const Download: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="21"
    fill="none"
    viewBox="0 0 21 21"
    width="21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d={`M17.5 13.8359V17.1693C17.5 17.6113 17.3244 18.0352 17.0118
      18.3478C16.6993 18.6603 16.2754 18.8359 15.8333 18.8359H4.16667C3.72464
      18.8359 3.30072 18.6603 2.98816 18.3478C2.67559 18.0352 2.5 17.6113 2.5
      17.1693V13.8359`}
      stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d={`M5.83398 9.66406L10.0007 13.8307L14.1673 9.66406`}
      stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
    <path d={`M10 13.8359V3.83594`} stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
  </svg>
);

export default Download;
